import config from "../../../config";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import { CustomContainer, Row, Col, Router } from "../../atoms/DependencyHelper";
import DropDownComponent from "../../atoms/dropDown/DropDown";
import Image from "../../atoms/image/image";
import styles from "./UpgradeDealsGrid.module.scss";
import { showSpinner, hideSpinner, componentCheckSize } from "../../../utils/helperServices";
import * as Analytics from "../../../services/analyticsUtag";
import { useSelector } from "react-redux";

const UpgradeDealsGrid = (props) => {
  const env = config.env;
const imagePrefix = config.envConfigs[env].imagePrefix;
const isMobile = componentCheckSize() < 576;
const financeIndicator = (useSelector(state => state.upgrade?.creditFilters?.financeIndicator) || "").toUpperCase();
const imgUrl = `${imagePrefix}/assets/images/no-filter-white.svg`;
const getUtagViewData = Analytics.getUtagData([
  "page_name",
"page_channel",
"page_master_tab",
"visitor_login_status",
"visitor_customer_id",
"visitor_id_hash", 
"visitor_msisdn_hash",
"visitor_subscription_type",
"page_site_section_lvl_1",
"page_site_section_lvl_2",
"upgrade_eligibility_status",
"upgrade_eligible_date",
"upgrade_customer_type"]);

const handleProducts=()=> {
  Analytics.link({
    ...getUtagViewData,
    link_type: "o",
    link_name: `${Analytics.getPageName()}: browse all products`,
  })
  showSpinner();
  Router.push(
    '/shopping/products'
  ).finally(()=>{
    window.scrollTo(0,0);
    hideSpinner();
  });
}
const handleDeals =()=> {
  Analytics.link({
    ...getUtagViewData,
    link_type: "o",
    link_name: `${Analytics.getPageName()}: browse all deals`,
  })
  showSpinner();
  if(props.maxLimit){
    Router.push(`/shopping/deals/monthly_recurring=minValue:0,maxValue:${props.maxLimit}`).finally(()=>{
      window.scrollTo(0,0);
      hideSpinner();
    });
  } else {
    Router.push(`/shopping/deals`).finally(()=>{
      window.scrollTo(0,0);
      hideSpinner();
    });
  }
}
  return (
    <CustomContainer className={styles["cta-container"]}>
      { !isMobile && (
      <CustomContainer className={styles["cta-text"]}>
      <CustomContainer className={styles["cta-text__icon"]}>
      <Image img_path={imgUrl} img_width='60px' img_height='60px' id="xbtn" />
      </CustomContainer>
      <CustomContainer >
        <CustomContainer className={styles["cta-heading"]}>{"Couldn’t find a deal you like?"}</CustomContainer>
        <CustomContainer className={styles["cta-description"]}>{" No problem! You can still find an upgrade deal by browsing the rest of our website."}</CustomContainer>

      </CustomContainer>
      </CustomContainer>
      )
}
      <CustomContainer className={styles["cta-list"]}>
            {financeIndicator === "Y" && (
                <CTAButton variant={isMobile ? "outline black":"link white"} handleClick={handleProducts} className={styles["cta-products"]}>{"Browse all products"}</CTAButton>
            )}
          <CTAButton variant={isMobile ? "outline black":"solid white"} handleClick={handleDeals} className={styles["cta-deals"]}>{"Browse all deals I qualify for"}</CTAButton>
      </CustomContainer>
    </CustomContainer>
  );
};

export default UpgradeDealsGrid;
